import apiClient from "@/lib/api/api-client";
import type { PortalUser } from "@/lib/api/login-user";

const PORTAL_ME_PATH = "/api/v1/me";

export async function fetchPortalMe(): Promise<PortalUser> {
  const { data } = await apiClient.get<PortalUser>(PORTAL_ME_PATH);
  return data;
}
